import { useEffect } from "react";

/** Título da aba; o anúncio da troca de página fica com o `Layout`. */
export function useTitulo(titulo: string): void {
  useEffect(() => {
    document.title = titulo === "Prisma" ? titulo : `${titulo} · Prisma`;
  }, [titulo]);
}
